import { LoginCard } from "./forms/LoginCard";

interface Props {
  setToken: any;
}

export const LoginForm: React.FC<Props> = ({ setToken }) => {
  return <LoginCard setToken={setToken} />;
};
